import React, { MutableRefObject, useCallback } from 'react';
import Webcam from 'react-webcam';
import { useSelector } from 'react-redux';
import { Portal } from '@material-ui/core';

import {
  selectStudioMode,
  selectStudioTopView,
} from '../../store/modules/studio/selectors';
import { StudioMode, StudioViewPositions } from '../../configs/studio';
import Camera from './camera/Camera';
import Prompter from './prompter/Prompter';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
  webcamRef: MutableRefObject<Webcam & HTMLVideoElement | null>;
  mainViewContainerId: string;
  bottomViewContainerId: string;
};

const ViewSwitcher = ({
  refPrompter,
  webcamRef,
  mainViewContainerId,
  bottomViewContainerId,
}: Props) => {
  const studioMode = useSelector(selectStudioMode);
  const topView = useSelector(selectStudioTopView);


  const mainViewContainer = useCallback(
    () => document.getElementById(mainViewContainerId),
    [mainViewContainerId],
  );

  const bottomViewContainer = useCallback(
    () => document.getElementById(bottomViewContainerId),
    [bottomViewContainerId],
  );

  switch (studioMode) {
    case StudioMode.CAMERA:
      switch (topView) {
        case StudioViewPositions.CAMERA:
          return (
            <>
              <Portal container={mainViewContainer}>
                <Camera
                  webcamRef={webcamRef}
                />
              </Portal>
              <Portal container={bottomViewContainer}>
                <Prompter
                  refPrompter={refPrompter}
                />
              </Portal>
            </>
          );
        case StudioViewPositions.TELEPROMPTER:
          return (
            <>
              <Portal container={mainViewContainer}>
                <Prompter
                  refPrompter={refPrompter}
                />
              </Portal>
              <Portal container={bottomViewContainer}>
                <Camera
                  webcamRef={webcamRef}
                />
              </Portal>
            </>
          );
        default:
          return null;
      }

    case StudioMode.TELEPROMPTER:
      return (
        <Portal container={mainViewContainer}>
          <Prompter
            refPrompter={refPrompter}
          />
        </Portal>
      );

    default:
      return null;
  }
};

export default ViewSwitcher;
